import axiosInstance from '@/utils/api.js'

var state = {
  tariffs: [],
  tariffLinksCount: [],
  tariffLinksHistory: [],
  scheduledTariffs: []
}

var getters = {
  TARIFFS: (state) => {
    return state.tariffs
  },
  TARIFF_LINKS_COUNT: (state) => {
    return state.tariffLinksCount
  },
  TARIFF_LINKS_HISTORY: (state) => {
    return state.tariffLinksHistory
  },
  SCHEDULED_TARIFFS: (state) => {
    return state.scheduledTariffs
  }
}

var mutations = {
  SET_TARIFFS: (state, payload) => {
    state.tariffs = payload
  },
  SET_TARIFF_LINKS_COUNT: (state, payload) => {
    state.tariffLinksCount = payload
  },
  SET_TARIFF_LINKS_HISTORY: (state, payload) => {
    state.tariffLinksHistory = payload
  },
  SET_SCHEDULED_TARIFFS: (state, payload) => {
    state.scheduledTariffs = payload
  }
}

var actions = {
  GET_TARIFFS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/tariffs')
    if (result.status === 200) {
      context.commit('SET_TARIFFS', result.data)
    }
  },
  GET_SCHEDULED_TARIFFS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/scheduled_tariffs?account_id=' + payload.account_id + '&tariff_slink_id=' + payload.tariff_slink_id)
    if (result.status === 200) {
      context.commit('SET_SCHEDULED_TARIFFS', result.data)
    }
  },
  CREATE_TARIFFS: (context, payload) => {
    return axiosInstance.post('/tariffing/tariff', payload)
  },
  CHANGE_USER_TARIFF_LINKS: (context, payload) => {
    return axiosInstance.post('/tariffing/schedule_tarifflink', payload)
  },
  UPDATE_TARIFFS: (context, payload) => {
    return axiosInstance.put('/tariffing/tariff', payload)
  },
  DELETE_TARIFFS: (context, payload) => {
    return axiosInstance.delete('/tariffing/tariff?tariff_id=' + payload)
  },
  DELETE_SERVICE_FROM_TARIFF: (context, payload) => {
    return axiosInstance.delete('/tariffing/delete_service_from_tariff?tariff_id=' + payload.tariff_id + '&service_id=' + payload.service_id)
  },
  DELETE_SCHEDULED_TARIFF: (context, payload) => {
    return axiosInstance.delete('/tariffing/scheduled_tariffs?account_id=' + payload.account_id +
    '&tariff_link_id=' + payload.tariff_link_id +
    '&tariff_id=' + payload.tariff_id +
    '&id=' + payload.id +
    '&change_date=' + payload.change_date)
  },
  GET_TARIFF_LINKS_COUNT: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/links_count?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TARIFF_LINKS_COUNT', result.data)
    }
  },
  GET_TARIFF_LINKS_HISTORY: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/tariffs_history?acc_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TARIFF_LINKS_HISTORY', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/tariff.js